import { bootstrap } from './src/bootstrap';

bootstrap();
